import * as React from "react";
import { useDataProvider, useNotify, useRecordContext, useRefresh } from "react-admin";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export function CopyTemplateButton() {
  const record = useRecordContext<any>();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  if (!record) return null;

  const onOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setName(`${record.name} (Kopie)`);
    setOpen(true);
  };

  const onSave = async () => {
    const newName = name.trim();
    if (!newName) {
      notify("Bitte einen Namen eingeben.", { type: "warning" });
      return;
    }

    setSaving(true);
    try {
      await dataProvider.create("training-templates/clone", {
        data: { sourceId: record.id, name: newName },
      });

      notify("Template kopiert.", { type: "info" });
      setOpen(false);
      refresh();
    } catch (e: any) {
      notify(e?.message ?? "Fehler beim Kopieren", { type: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ContentCopyIcon />}
        onClick={onOpen}
      >
        Kopieren
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Training kopieren</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <TextField
            autoFocus
            fullWidth
            label="Neuer Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={saving}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={saving}>
            Abbrechen
          </Button>
          <Button variant="contained" onClick={onSave} disabled={saving}>
            Kopieren
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
